<button class="btn" [attr.type]="type" [disabled]="disabled">
  <span>{{ label }}</span>
</button>
